import inviewAnim from "./modules/inview";
import { setModal, globalNav } from "./modules/libs";
import { slider } from "./modules/slider";
import { navHover } from "./modules/nav";
import setAccordion from "./modules/setAccordion";
import setForm from "./modules/form";

window.addEventListener("load", () => {
  inviewAnim();
  slider.init();
  setModal();
  globalNav();
  setAccordion();
  navHover();
  setForm();
});
